import { ArrowsInIcon } from "@phosphor-icons/react/dist/csr/ArrowsIn";
import { ArrowsOutIcon } from "@phosphor-icons/react/dist/csr/ArrowsOut";
import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { TooltipShortcut } from "@volca/ui/components/ui/tooltip-shortcut";
import { ToolbarSegment } from "./toolbar-segment";

interface FullScreenToggleProps {
  isMaximized: boolean;
  onToggleMaximize: () => void;
}

export const FullScreenToggle = ({
  isMaximized,
  onToggleMaximize,
}: FullScreenToggleProps) => (
  <ToolbarSegment>
    <TooltipProvider delay={200}>
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              variant="ghost"
              size="icon-sm"
              onClick={onToggleMaximize}
              aria-label={isMaximized ? "Exit full screen" : "Full screen"}
            />
          }
        >
          {isMaximized ? <ArrowsInIcon /> : <ArrowsOutIcon />}
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <TooltipShortcut keys={isMaximized ? ["Esc"] : ["mod", "shift", "F"]}>
            {isMaximized ? "Exit full screen" : "Full screen"}
          </TooltipShortcut>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </ToolbarSegment>
);
